/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { Context } from '~context/MainProvider';
import formattedDate from '../../../../helpers/formattedDate';
import FeaturedMatch from '../../../atoms/featured-match';
import styles from './match-card.module.scss';

/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-danger */

const MatchCard = ({ item }) => {
  const { translations } = useContext(Context) || {};
  // eslint-disable-next-line camelcase
  const { date, extra_fields } = item || '';

  const subtitle =
    extra_fields?.subtitle ||
    `${translate(translations, 'watch', 'Watch')}
     ${item?.home_team?.name} - ${item?.away_team?.name} | 
     ${translate(translations, 'live_stream_online', 'Live Stream Online')}
    `;

  const ctaText =
    extra_fields?.cta_text ||
    `${translate(translations, 'watch', 'Watch')} ${item?.home_team?.name} vs ${
      item?.away_team?.name
    } online`;

  return (
    <div className={styles.matchCard}>
      <p className={styles.date}>{formattedDate(date, translations)}</p>
      <FeaturedMatch type="soccer" context="cards" item={item} />
      <div className={styles.description}>
        <p>{subtitle}</p>
      </div>
      <Button
        to={item?.path}
        className="matchCards"
        isInternalLink
        btnText={
          <>
            <span>{ctaText}</span>
            <FaArrowRight />
          </>
        }
        gtmClass="match-card-gtm btn-cta"
      />
    </div>
  );
};

MatchCard.propTypes = {
  item: PropTypes.shape({
    path: PropTypes.string,
    description: PropTypes.string,
    home_team: PropTypes.shape({
      name: PropTypes.string,
    }),
    away_team: PropTypes.shape({
      name: PropTypes.string,
    }),
    tournament: PropTypes.shape({
      name: PropTypes.string,
    }),
    date: PropTypes.shape({
      day_number: PropTypes.number,
      month_short: PropTypes.string,
      year_number: PropTypes.number,
      time: PropTypes.string,
    }),
  }),
  page: PropTypes.shape({}),
};

export default MatchCard;
